import { TransportType } from '@/features/shared/models/TransportType';
import { NotificationType } from '@/features/messages/NotificationType';

export enum DriverMessageInputType {
    ShortText = 0,
    Number = 1
}

export interface MessageInputTemplate {
    name: string;
    label: string;
    inputType: DriverMessageInputType;
    value: string;
}

export interface MessageChoiceTemplate {
    name: string;
    label: string;
    group: string;
    groupLabel: string;
}

export interface MessageTemplate {
    id: string;
    name: string;
    label: string;
    categoryName: string;
    categoryLabel: string;
    transportTypes: TransportType[];
    notificationType: NotificationType;
    inputTemplates: MessageInputTemplate[];
    choiceTemplates: MessageChoiceTemplate[];
    isFirstLevel: boolean;
}

export interface CategoryTemplate {
    name: string;
    label: string;
    messageTemplates: MessageTemplate[];
}
